import $ from 'jquery';
import mobile from 'is-mobile';
import {toggleBodyScroll} from '../base/utils';

class Layer {
    constructor() {
        this.$body = $('body');

        this.init();
        this.events();
    }

    init() {

    }

    open($layer, source) {
        let scrollBarWidth = window.innerWidth - document.body.clientWidth + 'px';

        $layer.css('padding-right', scrollBarWidth);
        $layer.addClass('layer-open');

        if (source !== undefined) {
            $layer.find('.webform-wrap').find('[name="track_source"]').val(source);
        }

        this.$body
            .addClass('layer-visible')
            .toggleClass('mobile-layer-visible', mobile({tablet: true, featureDetect: true}))
            .trigger('layer-open', $layer);

        toggleBodyScroll(true);
    }

    events() {
        this.$body.on('click', '.js-layer-trigger', e => {
            e.preventDefault();

            // let layerId = e.currentTarget.href ? e.currentTarget.href.split('#')[1] : e.currentTarget.dataset.formId,
            let layerId = e.currentTarget.dataset.href ? e.currentTarget.dataset.href.split('#')[1] : e.currentTarget.dataset.formId,
                $layer = $(`#${layerId}`),
                source = $(e.currentTarget).attr('data-source');

            this.$body.removeClass('menu-open');

            this.open($layer, source);
        });
        this.$body.on('click', '.js-layer-close', e => {
            e.preventDefault();

            let $layer = $('.layer.layer-open');

            this.$body
                .removeClass('layer-visible mobile-layer-visible')
                .trigger('layer-closing', $layer);

            $layer.css('padding-right', '');
            $layer.removeClass('layer-open');
            toggleBodyScroll(false);

            setTimeout(() => {this.$body.trigger('layer-closed', $layer); }, 300);
        });
        this.$body.on('open', '.layer', (e, data) => {
            this.open($(e.currentTarget), data ? data.source : undefined);
        });
    }
}

export default Layer;



// WEBPACK FOOTER //
// ./sources/js/components/layer.js